import { render, staticRenderFns } from "./EkrmTradeCard.vue?vue&type=template&id=2f62516c&scoped=true&"
import script from "./EkrmTradeCard.vue?vue&type=script&lang=js&"
export * from "./EkrmTradeCard.vue?vue&type=script&lang=js&"
import style0 from "./EkrmTradeCard.vue?vue&type=style&index=0&id=2f62516c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f62516c",
  null
  
)

export default component.exports